const MARKETING_SITE_ORIGIN = 'https://www.restworld.it';

/**
 * Where the "find out more" link on a professional association badge points.
 *
 * Derived from the association's Variable `key` rather than read from a column,
 * which is why `variables` carries no URL field: the marketing site already owns
 * `/partner/<key>`, and for APCI that is the live `/partner/apci`. An
 * association we have no landing page for simply has no link, and the badge
 * drops its last line rather than sending anyone to a 404.
 *
 * Deliberately not built from `BASE_URL`. That constant follows the environment
 * (`dev.worker.restworld.it`, `localhost:4200`), and none of those hosts serve
 * `/partner/*` — the marketing site is the same site in every environment.
 */
export const partnerLandingUrl = (key?: string): string | undefined =>
  key ? `${MARKETING_SITE_ORIGIN}/partner/${key}` : undefined;
